export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";